import { configuration } from '../configs'
import { PaginationBody, PaginationBodyUsers } from '@Entities/pagination'
import { Sort } from '@Entities/search'
import { isArray } from 'lodash'
import { Auth } from '@App/dicts/auth'
import { User } from '@App/dicts/user'
import { Notification } from '@App/dicts/notification'
import { RightsHolder } from '@App/dicts/rightsholder'
import { Report } from '@App/dicts/report'
import { Search } from '@App/dicts/search'
import { Work } from '@App/dicts/work'
import { Lib } from '@App/dicts/lib'
import { Upload } from '@App/dicts/upload'
import { Songwriter } from '@App/dicts/songwriter'
import { Public } from '@App/dicts/public'
import { SystemSettings } from '@App/dicts/system-settings'

export const base = (rest: string) => `${configuration.api}/${rest}`

export const base2v = (rest: string) => `${configuration.api2v}/${rest}`
export const publicBase2v = (rest: string) => `${configuration.api2v}/public/${rest}`
export const portalBase2v = (rest: string) => `${configuration.api2v}/portal/${rest}`
export const rightsholderBase2v = (ipId: number, rest?: string) =>
    `${configuration.api2v}/rightsholder/${ipId}${rest ? `/${rest}` : ''}`
export const songwriterBase2v = (ipId: string, rest?: string) =>
    `${configuration.api2v}/songwriter/${ipId}${rest ? `/${rest}` : ''}`

export const paginationPath = (pagination?: PaginationBody) => {
    if (pagination) {
        return `?page=${pagination.page}&limit=${pagination.limit}${
            pagination.source ? `&source=${pagination.source}` : ''
        }`
    } else {
        return
    }
}

export const paginationPath2v = (pagination: PaginationBody | undefined) =>
    `?page=${pagination?.page ? pagination.page - 1 : 0}&size=${pagination?.limit ?? 10}${
        pagination?.source ? `&source=${pagination.source}` : ''
    }`

export const paginationSearchPath = (pagination: PaginationBody) => {
    if (pagination) {
        return `?page=${pagination.page}&limit=${pagination.limit}${pagination.refined ? `&refined` : ''}`
    } else {
        return
    }
}

export const paginationUserPath = (pagination: Partial<PaginationBodyUsers>) => {
    if (pagination && !pagination.group) {
        return `?page=${pagination.page}&limit=${pagination.limit}`
    } else if (pagination) {
        return `?page=${pagination.page}&limit=${pagination.limit}&group=${pagination.group}`
    } else {
        return
    }
}

export const applyMultiSort = (url: URL, pagination?: PaginationBody) => {
    if (pagination) {
        const sortToApply = isArray(pagination.sort) ? pagination.sort : [pagination.sort]
        sortToApply.forEach((item) => {
            if ((item as Sort)?.field !== undefined) {
                const sort = item as Sort
                url.searchParams.append('sort', `${sort.field},${sort.direction ?? 'asc'}`)
            }
        })
    }
}

export default class Pathes {
    static Auth = new Auth()

    static User = new User()

    static Notification = new Notification()

    static RightsHolder = new RightsHolder()

    static Report = new Report()

    static Search = new Search()

    static Work = new Work()

    static Lib = new Lib()

    static Upload = new Upload()

    static Songwriter = new Songwriter()

    static Public = new Public()

    static SystemSettings = new SystemSettings()
}
